import { DatasetAreaChart } from "./charts/dataset-area-chart"
import { useQueryResults } from "@/hooks/useQueryResults"
import { useMemo } from "react"

export default function MorphoV2Stables() {
    const { results } = useQueryResults({id: 6819416})

    const formatter = new Intl.NumberFormat("en", {notation: "compact"})
    const tooltipFormatter = new Intl.NumberFormat("en", {maximumFractionDigits: 0})

    const formattedData = useMemo(() => {
        if (!results) return {dimensions: [], source: []}
        const series = [...new Set(results.map(r => r.symbol as string)).keys()].filter(v => !!v)
        const days = [...new Set(results.map(r => r.date.valueOf())).keys()].map((d) => new Date(d))
        const dimensions = ['date', ...series]
        const source = days.map(d => {
            const filtered = results.filter(r => r.date.valueOf() === d.valueOf())
            return [
                d, ...dimensions.slice(1).map(s => {
                    const data = filtered.filter(r => r.symbol === s).at(0)
                    if (!data) return 0
                    return (data.balance)
                }) as (string | number)[]
            ]
        }) 

        return {
            dimensions,
            source
        }
    }, [results])

    return <div className="w-full h-[40vh]">
        <DatasetAreaChart
            dataset={formattedData}
            title="Morpho V2 Stablecoin Deposits"
            description="Major Stablecoin deposits in V2 Vaults including USDC, USDT, PYUSD, USDS and RLUSD"
            stack
            yAxisFormatter={(n) => formatter.format(n)}
            tooltip={{
                seriesValueFormatter: (value) => `$${tooltipFormatter.format(value)}`
            }}
            showTotal={true}
        />
    </div>
}
